import { ChartBarIcon } from "@heroicons/react/outline";
import { observer } from "mobx-react-lite";

import { getAnalyticsDisabledTooltip } from "@/components/RequestsAnalytics/utils/getAnalyticsDisabledTooltip";
import { useStructuredSearchStore } from "@/components/StructuredSearch";
import { Button } from "@/components/ui/button";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { isOlderDataSearch } from "@/routes/request-logs/search/older-data";

interface OpenAnalyticsButtonProps {
  onClick: () => void;
  /** Workspace cutover date (`search_cutover_date` or `traces_search_cutover_date`). */
  cutoverDate?: string | null;
}

const OpenAnalyticsButton = observer(({ onClick, cutoverDate }: OpenAnalyticsButtonProps) => {
  const structuredSearchStore = useStructuredSearchStore();
  const isDisabled = isOlderDataSearch(structuredSearchStore.dateRange, cutoverDate);
  const disabledTooltip = isDisabled
    ? getAnalyticsDisabledTooltip(cutoverDate ?? undefined)
    : undefined;

  return (
    <BasicTooltip content={disabledTooltip} shouldShow={Boolean(disabledTooltip)}>
      <span className={isDisabled ? "inline-flex cursor-not-allowed" : "inline-flex"}>
        <Button
          type="button"
          variant="outline"
          className="h-10 gap-2 px-3 text-sm"
          onClick={onClick}
          disabled={isDisabled}
          aria-label="Open analytics for the current filters"
        >
          <ChartBarIcon className="h-4 w-4" aria-hidden="true" />
          Analytics
        </Button>
      </span>
    </BasicTooltip>
  );
});

export default OpenAnalyticsButton;
